import { Children, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useSwiper } from "swiper/react";
import "swiper/css";
import { Pagination, Navigation } from "swiper/modules";
import "./MobileCarousel.css";
export default function MobileCarousel(props) {
  const { children, plans } = props;
  const [activeIndex, activeIndexSet] = useState(0);

  useEffect(() => {
    if (plans.findIndex((plan) => plan.topOffer === 1) !== -1) {
      activeIndexSet(plans.findIndex((plan) => plan.topOffer === 1));
    }
  }, []);

  const onSlideChange = (currentSlide) => {
    activeIndexSet(currentSlide.activeIndex);
  };

  return (
    <Swiper
      spaceBetween={20} //Uniquement lors du slide
      slidesPerView={1.2}
      initialSlide={plans.findIndex((plan) => plan.topOffer === 1)}
      centeredSlides
      modules={[Navigation, Pagination]}
      onSlideChange={onSlideChange}
    >
      <CarouselPagination plans={plans} activeIndex={activeIndex} />
      {Children.map(children, (child) => (
        <SwiperSlide>
          <div className="carousel-card">{child}</div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}

const CarouselPagination = ({ plans, activeIndex }) => {
  const prevPlan = plans[activeIndex - 1];
  const nextPlan = plans[activeIndex + 1];

  return (
    <div className="carousel-pagination">
      <div style={prevPlan ? {} : { visibility: "hidden" }}>
        <SwiperButtonPrev>
          <ChevronLeft />
          {prevPlan?.d?.name}
        </SwiperButtonPrev>
      </div>

      {plans.length && <Bullets plans={plans} activeIndex={activeIndex} />}

      <div style={nextPlan ? {} : { visibility: "hidden" }}>
        <SwiperButtonNext>
          {nextPlan?.d?.name}
          <ChevronRight />
        </SwiperButtonNext>
      </div>
    </div>
  );
};

const SwiperButtonNext = ({ style = {}, children }) => {
  const swiper = useSwiper();
  return (
    <button className="carousel-button" onClick={() => swiper.slideNext()}>
      {children}
    </button>
  );
};

const SwiperButtonPrev = ({ style = {}, children }) => {
  const swiper = useSwiper();
  return (
    <button className="carousel-button" onClick={() => swiper.slidePrev()}>
      {children}
    </button>
  );
};

const Bullets = ({ plans, activeIndex }) => {
  return (
    <div className="carousel-bullets">
      {plans.map((p, i) => (
        <div className={`carousel-bullet ${activeIndex === i ? "carousel-bullet-active" : ""}`} key={`bullet-${i}`} />
      ))}
    </div>
  );
};
